// CourseContext.tsx
import { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import type {IContact} from '../interfaces/IContact';
// import type {ICourse} from '../interfaces/ICourse';
// import axios from 'axios';
import axiosInstance from "../helpers/Axios";
import type { IStage } from '../interfaces/IStage';

interface IStageObj {
    stage: IStage;
    subscribes: IContact[];
    nbSubscribes: number;
}

interface StageContextType {
    list: IStageObj[];
    loading: boolean;
}

const defaultList: IStageObj[] = [];

const StageContext = createContext<StageContextType | undefined>(undefined);

interface StageProviderProps { children: ReactNode; }

export const StageProvider = ({ children }: StageProviderProps) => {
    const [list, setList] = useState(defaultList);
//   const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(true);
    const loading = list === defaultList && visible;

//   useEffect(() => {
//     axios.get('/course')
//       .then(res => setList(res.data))
//       .finally(() => setLoading(false));
//   }, []);

    useEffect(() => {
        // console.log("Fetching /stage");
        if (loading)
            axiosInstance.get("/stage")
                .then(response => {
                    
                    // console.log('response', response);

                    setList(response.data);//.map((courseObj : ICourseObj) => courseObj.course))
                    // setUserProfile(response.data);
                    // setLocation(response.data.location);
                })
                .catch((err) => {
                    const error = err.response === undefined ?
                        'Server in not reachable'
                        : err.response.data;
                    console.log('error', error);
                    setVisible(false);
                });
    }, []);

  return (
    <StageContext.Provider value={{ list, loading }}>
      {children}
    </StageContext.Provider>
  );
};

export const useStages = () => { 
    const context = useContext(StageContext); 
    if (!context) 
        throw new Error("useStages must be used within a StageProvider"); 
    return context; 
};
// End of StageContext.tsx